<template>
  <div
    v-if="modalTrigger"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  >
    <div
      class="bg-white w-full max-w-xl mx-4 p-6 rounded-xl shadow-lg relative overflow-hidden"
    >
      <div class="flex items-center pt-4 pb-5">
        <button
          @click="handleClose()"
          class="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-2xl font-bold"
        >
          &times;
        </button>
        <h2 class="text-xl font-semibold text-secondary">
          Import MAMS Approval
        </h2>
      </div>

      <hr class="pb-5" />
      <form action="" @submit.prevent="getMAMSApprovalNo()">
        <div class="flex gap-1 flex-col">
          <label class="block text-xs text-gray-700 pb-3"
            >Membername: <span>{{ modalDetails.membername }}</span></label
          >
          <label class="block text-xs text-gray-700 pb-3"
            >Company: <span>{{ modalDetails.company }}</span></label
          >
          <label class="block text-xs text-gray-700 pb-3"
            >Approval Number<span class="text-red-600">*</span></label
          >
          <div class="flex gap-3 justify-between">
            <input
              :class="[
                'w-full border shadow-elegant rounded-md px-4 py-2.5 text-xs',
                !approvalnumber ? 'border-gray-300' : 'border-gray-300',
              ]"
              v-model="approvalnumber"
              type="text"
              placeholder="Input Approval Number"
            />

            <button
              class="px-4 py-2.5 bg-blue-100 text-blue-700 text-xs font-medium rounded-md shadow-sm"
            >
              <template v-if="!isLoading">Verify</template>
              <template v-else>
                <svg
                  class="animate-spin h-5 w-5 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="4"
                  />
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                  />
                </svg>
              </template>
            </button>
          </div>
        </div>
      </form>
      <button
        :disabled="!itemDetails.length"
        @click="passToApplicationOne"
        class="my-4 w-full px-4 py-2.5 bg-primary text-white hover:bg-orange-500 transition text-xs font-medium rounded-md shadow-sm cursor-pointer"
      >
        Import
      </button>
      <div v-if="isTrigger">
        <span
          v-if="!itemDetails.length"
          class="block p-3 text-sm text-red-800 bg-red-100 border border-red-300 rounded-lg"
        >
          {{ noDataMessage }}
        </span>
        <span
          v-else
          class="block p-3 text-sm text-green-800 bg-green-100 border border-green-300 rounded-lg"
        >
          {{ noDataMessage }}
        </span>
      </div>

      <span
        v-if="duplicateMessage.length"
        class="block p-3 text-sm text-red-800 bg-red-100 border border-red-300 rounded-lg"
      >
        {{ duplicateMessage }}
      </span>
    </div>
  </div>
</template>
<script>
import { inject, ref } from "vue";
export default {
  props: {
    modalTrigger: {
      type: Boolean,
      required: true,
    },
    modalDetails: {
      type: Object,
      required: true,
    },
  },
  emits: ["close", "passData"],
  setup(props, { emit }) {
    const approvalnumber = ref();
    const noDataMessage = ref();
    const itemDetails = ref([]);
    const isAlert = ref(false);
    const isLoading = ref(false);
    const isTrigger = ref(false);
    const axios = inject("$axios");
    const duplicateMessage = ref("");
    const handleClose = () => {
      emit("close", false);
    };

    const getMAMSApprovalNo = async () => {
      try {
        isLoading.value = true;
        duplicateMessage.value = "";
        const { data } = await axios.get(
          `https://deped-api.onrender.com/reimbursement/integration`,
          {
            params: {
              approvalno: approvalnumber.value,
            },
          }
        );

        isLoading.value = false;

        //itemDetails.value = data.length;

        if (data.length) {
          itemDetails.value = data;
        } else {
          itemDetails.value = [];
        }
        isAlert.value = true;
        isTrigger.value = true;
        if (!itemDetails.value.length) {
          noDataMessage.value = "Approval Number is Invalid";
        } else {
          noDataMessage.value = "Approval Number is Valid";
        }

        setTimeout(() => {
          isTrigger.value = false;
        }, 10000);
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
    };
    const passToApplicationOne = async () => {
      try {
        const { data } = await axios.get(
          `/portal/application/reimbursement/approvalno`,
          {
            params: {
              approvalno: approvalnumber.value,
            },
          }
        );
        if (data.status) {
          duplicateMessage.value = "Approval Number Already Exist.";
          isTrigger.value = false;
        } else {
          duplicateMessage.value = "";
          emit("passData", itemDetails.value);
          emit("close", false);
        }
      } catch (error) {
        console.log(error);
      }
    };
    return {
      handleClose,
      getMAMSApprovalNo,
      approvalnumber,
      itemDetails,
      passToApplicationOne,
      noDataMessage,
      isAlert,
      isLoading,
      isTrigger,
      duplicateMessage,
    };
  },
};
</script>
